import { useState } from "react";

/**
 * Runs `reset()` during render whenever `trigger` changes (compared via
 * `Object.is`). Drop-in replacement for the common pattern:
 *
 *     useEffect(() => { ... setState(...) ... }, [trigger])
 *
 * Running the reset during render (instead of after commit) is endorsed by
 * the React docs for "reset state when a prop changes" scenarios and
 * satisfies the React Compiler's `react-hooks/set-state-in-effect` rule
 * because nothing happens inside an effect.
 *
 * See: https://react.dev/reference/react/useState#storing-information-from-previous-renders
 */
export function useResetOnChange<T>(trigger: T, reset: () => void): void {
  const [prev, setPrev] = useState(trigger);
  if (!Object.is(prev, trigger)) {
    setPrev(trigger);
    reset();
  }
}
